import { useState } from "react";
import Index from "./pages/index";
import Home from "./pages/home";
import Key from "./pages/key";


export default function Matt() {
const [activeTab, setActiveTab] = useState("index");

return (
        <div>
            {/* Main content */}
            <main style = {{margin: "0px", padding: "0px"}}>
                {activeTab === "index" && <Index enter = {() => setActiveTab("home")}/>}
                {activeTab === "home" && <Home goKey ={() => setActiveTab("key")}/>}
                {activeTab === "key" && <Key goHome ={() => setActiveTab("home")}/>}
            </main>
        </div>
    );
}